import { nullable, struct } from 'io-ts/Decoder';

import { Id as CollaboratorType } from '../../../../transaction/collaborator/type/Id';
import { Id as TransactionId } from '../../../../transaction/Id';

export const Params = struct({
	transactionId: TransactionId,
	collaboratorType: nullable(CollaboratorType),
});
